import { createReducer, on } from '@ngrx/store';
import { ILinkedBusinessesRequest } from '../models/linked-businesses.model';
import * as action from '../actions';

export const assetManagerViewLinkedBusinessesFeatureKey = 'assetManagerViewLinkedBusinesses';

export interface AssetManagerViewLinkedBusinessesState {
  loadAssetManagerViewLinkedBusinessesRequest: ILinkedBusinessesRequest;
  loadAssetManagerViewLinkedBusinessesResponse: any;
  loadAssetManagerViewLinkedBusinessesFailure: any | Error;
  loaded: boolean;
}

export const initialState: AssetManagerViewLinkedBusinessesState = {
  loadAssetManagerViewLinkedBusinessesRequest: undefined,
  loadAssetManagerViewLinkedBusinessesResponse: undefined,
  loadAssetManagerViewLinkedBusinessesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(action.loadAssetManagerViewLinkedBusinesses, (state, action) => ({
    ...state,
    loadAssetManagerViewLinkedBusinessesRequest: action.request
  })),
  on(action.loadAssetManagerViewLinkedBusinessesSuccess, (state, action) => ({
    ...state,
    loadAssetManagerViewLinkedBusinessesResponse: action.response,
    loaded: true
  })),
  on(action.loadAssetManagerViewLinkedBusinessesFailure, (state, action) => ({
    ...state,
    loadAssetManagerViewLinkedBusinessesFailure: action.error
  }))
);

export const getAssetManagerViewLinkedBusinessesList = (state: AssetManagerViewLinkedBusinessesState) => {
  let parse;

  if (state.loadAssetManagerViewLinkedBusinessesResponse !== undefined) {
    const stringify = JSON.stringify(state.loadAssetManagerViewLinkedBusinessesResponse);
    parse = JSON.parse(stringify);
  }
  return parse;
};

export const getAssetManagerViewLinkedBusinessesIsLoaded = (state: AssetManagerViewLinkedBusinessesState) => state.loaded;
